import { RenderFunction } from '../interfaces'
import { render as a } from './link'

const renderers: Record<string, RenderFunction> = {
  a,
}

export default renderers
